import { render, staticRenderFns } from "./QuestionExplainDetailModal.vue?vue&type=template&id=13b19bbc"
import script from "./QuestionExplainDetailModal.vue?vue&type=script&lang=js"
export * from "./QuestionExplainDetailModal.vue?vue&type=script&lang=js"
import style0 from "./QuestionExplainDetailModal.vue?vue&type=style&index=0&id=13b19bbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports